import { useAppStore } from '../store/useAppStore';
import { Button, Modal } from './ui';

/**
 * What a reader gets the first time they try to change a plan.
 *
 * Not shown on opening, and deliberately: looking at somebody's scenario should
 * cost them nothing and should not put a file in your Drive you never asked
 * for. The question only arises once there is a change that has nowhere of
 * yours to land.
 *
 * The copy is a plan of your own, and it stops there — Drive decides who may
 * write to the original, and offering to ask on your behalf would be this app
 * inventing a sharing model on top of the one that already exists.
 */
export function CopyPrompt() {
  const open = useAppStore((s) => s.copyPrompt);
  const name = useAppStore((s) => s.scenario?.name);
  const copyForEditing = useAppStore((s) => s.copyForEditing);
  const dismiss = useAppStore((s) => s.dismissCopyPrompt);

  return (
    <Modal
      open={open}
      onClose={dismiss}
      title="You have view access to this plan"
      description={
        name
          ? `“${name}” was shared with you to read. Make a copy and the change lands there instead.`
          : 'This plan was shared with you to read.'
      }
      footer={
        <>
          <Button variant="ghost" onClick={dismiss}>
            Keep reading
          </Button>
          <Button variant="primary" onClick={() => void copyForEditing()}>
            Make a copy
          </Button>
        </>
      }
    >
      <p className="text-[13px] text-[var(--color-ink-3)]">
        The copy is yours, in your own Drive, and starts from everything this plan has in it — including its
        history. The original is untouched.
      </p>
      <p className="mt-2 text-[13px] text-[var(--color-ink-3)]">
        To change this one instead, ask whoever shared it to give you edit access in Drive.
      </p>
    </Modal>
  );
}
